export default console
